module.exports = __webpack_public_path__ + "maxus.bbed683bd4ba385c5bca.png";